import { InjectionToken, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { environment } from 'src/environments/environment';
import { EnvironmentDeploy } from 'src/environments/models/environment-deploy';

export const APP_BASE_URL = new InjectionToken<string>('');
export const VIEWER_BASE_URL = new InjectionToken<string>('');

export const appBaseUrl =
  environment.deploy === EnvironmentDeploy.Production
    ? 'https://human.biodigital.com' // use explicit production host
    : window.location.origin; // current host

export const viewerBaseUrl =
  environment.deploy === EnvironmentDeploy.Local
    ? 'https://localhost:4202' // use local viewer
    : `${appBaseUrl}/viewer`; // default viewer path

@NgModule({
  declarations: [],
  imports: [CommonModule],
  providers: [
    { provide: APP_BASE_URL, useValue: appBaseUrl },
    { provide: VIEWER_BASE_URL, useValue: viewerBaseUrl },
  ],
})
export class AppConfigModule {}
